module.exports = __webpack_public_path__ + "static/media/Societe-Construction-Immobilier-Vaud.f2b053bd.jpg";